var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-modal', {
    attrs: {
      "id": "raiseIssueModal",
      "centered": "",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "hide-header-close": "",
      "modal-class": "iha-modal"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-clients-header"
        }, [_c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('div', {
    staticClass: "issue-modal-card"
  }, [_c('h5', {
    staticClass: "modal-title mb-3"
  }, [_vm._v("Submit an Issue")]), _c('div', {
    staticClass: "form-group mb-3 position-relative"
  }, [_c('label', {
    staticClass: "mb-2"
  }, [_vm._v("Issue Type "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "position-relative"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.status,
      expression: "status"
    }],
    staticClass: "form-control custom-select",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, function ($event) {
        _vm.markError = '';
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Type")]), _vm._l(_vm.issueTypes, function (item) {
    return _c('option', {
      key: item,
      domProps: {
        "value": item
      }
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  })], 2), _c('i', {
    staticClass: "fas fa-angle-down dropdown-icon"
  })]), _vm.markError ? _c('small', {
    staticClass: "field-error"
  }, [_vm._v(_vm._s(_vm.markError))]) : _vm._e()]), _c('div', {
    staticClass: "form-group mb-3 position-relative"
  }, [_c('label', {
    staticClass: "mb-2"
  }, [_vm._v("Member "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "position-relative"
  }, [_vm.modalVisible ? _c('multiselect', {
    attrs: {
      "options": _vm.members,
      "custom-label": _vm.getMemberLabel,
      "loading": _vm.isLoadingMembers,
      "internal-search": false,
      "clear-on-select": true,
      "close-on-select": true,
      "options-limit": 50,
      "limit": 10,
      "track-by": "member_id",
      "placeholder": "Select Member"
    },
    on: {
      "search-change": _vm.onMemberSearch,
      "input": function input($event) {
        _vm.memberError = '';
      }
    },
    model: {
      value: _vm.member,
      callback: function callback($$v) {
        _vm.member = $$v;
      },
      expression: "member"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_vm._v("No members found. Consider changing the search query.")])], 2) : _vm._e()], 1), _vm.memberError ? _c('small', {
    staticClass: "field-error"
  }, [_vm._v(_vm._s(_vm.memberError))]) : _vm._e()]), _c('div', {
    staticClass: "form-group mb-3 position-relative"
  }, [_c('label', {
    staticClass: "mb-2"
  }, [_vm._v("Plan "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "position-relative"
  }, [_vm.modalVisible ? _c('multiselect', {
    attrs: {
      "options": _vm.plans,
      "custom-label": _vm.getPlanLabel,
      "loading": _vm.isLoadingPlans,
      "internal-search": false,
      "clear-on-select": true,
      "close-on-select": true,
      "options-limit": 50,
      "limit": 10,
      "track-by": "pid",
      "placeholder": "Select Plan"
    },
    on: {
      "search-change": _vm.onPlanSearch,
      "input": function input($event) {
        _vm.planError = '';
      }
    },
    model: {
      value: _vm.plan,
      callback: function callback($$v) {
        _vm.plan = $$v;
      },
      expression: "plan"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_vm._v("No plans found. Consider changing the search query.")])], 2) : _vm._e()], 1), _vm.planError ? _c('small', {
    staticClass: "field-error"
  }, [_vm._v(_vm._s(_vm.planError))]) : _vm._e()]), _c('div', {
    staticClass: "form-group mb-3"
  }, [_c('label', {
    staticClass: "mb-2"
  }, [_vm._v("Issue Description "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.note,
      expression: "note"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "placeholder": "Describe the issue..."
    },
    domProps: {
      "value": _vm.note
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value;
      }, function ($event) {
        _vm.noteError = '';
      }]
    }
  }), _vm.noteError ? _c('small', {
    staticClass: "field-error"
  }, [_vm._v(_vm._s(_vm.noteError))]) : _vm._e()]), _c('div', {
    staticClass: "form-group mb-3"
  }, [_c('label', {
    staticClass: "mb-2"
  }, [_vm._v("Attachments")]), _c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.triggerFileInput
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Files")]), _c('span', {
    staticClass: "file-names",
    class: {
      empty: !_vm.files.length
    }
  }, [_vm._v(" " + _vm._s(_vm.files.length ? "".concat(_vm.files.length, " file").concat(_vm.files.length > 1 ? 's' : '', " selected") : "No file chosen") + " ")]), _c('input', {
    ref: "fileInput",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": ".pdf,.png,.jpg,.jpeg"
    },
    on: {
      "change": _vm.handleFile
    }
  })]), _c('div', {
    staticClass: "upload-info"
  }, [_vm._v(" Upload supporting documents (PDF, JPG, PNG). Max 5MB. ")]), _vm.files.length ? _c('div', {
    staticClass: "attachment-list mt-3"
  }, _vm._l(_vm.files, function (file, index) {
    return _c('div', {
      key: file.id,
      staticClass: "attachment-card"
    }, [_c('button', {
      staticClass: "attachment-preview-trigger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.previewFile(file);
        }
      }
    }, [_c('span', {
      staticClass: "attachment-icon",
      class: {
        'is-pdf': _vm.isPdf(file)
      }
    }, [_c('i', {
      class: _vm.isPdf(file) ? 'far fa-file-pdf' : 'far fa-image'
    })]), _c('span', {
      staticClass: "attachment-meta"
    }, [_c('span', {
      staticClass: "attachment-name",
      attrs: {
        "title": file.name
      }
    }, [_vm._v(_vm._s(file.name))]), _c('span', {
      staticClass: "attachment-size"
    }, [_vm._v(_vm._s(_vm.formatFileSize(file.size)))])])]), _c('div', {
      staticClass: "attachment-actions"
    }, [_c('button', {
      staticClass: "attachment-action-btn",
      attrs: {
        "type": "button",
        "title": "Preview",
        "aria-label": "Preview attachment"
      },
      on: {
        "click": function click($event) {
          return _vm.previewFile(file);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-eye"
    })]), _c('button', {
      staticClass: "attachment-remove-btn",
      attrs: {
        "type": "button",
        "title": "Remove",
        "aria-label": "Remove attachment"
      },
      on: {
        "click": function click($event) {
          return _vm.removeFile(index);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-times"
    })])])]);
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "modal-actions mt-4"
  }, [_c('button', {
    staticClass: "btn btn-secondary fs-14",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Cancel ")]), _c('button', {
    staticClass: "btn btn-linear-primary fs-14",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.saveNote
    }
  }, [_vm._v(" " + _vm._s(_vm.isLoading ? "Submitting..." : "Submit Issue") + " ")])])])]), _c('b-modal', {
    attrs: {
      "size": "xl",
      "centered": "",
      "hide-footer": "",
      "hide-header-close": "",
      "modal-class": "attachment-preview-modal",
      "content-class": "attachment-preview-content",
      "body-class": "attachment-preview-body"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "attachment-preview-header"
        }, [_c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closePreviewModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.previewModalVisible,
      callback: function callback($$v) {
        _vm.previewModalVisible = $$v;
      },
      expression: "previewModalVisible"
    }
  }, [_vm.previewFileItem ? _c('div', {
    staticClass: "attachment-preview-shell"
  }, [_vm.isImage(_vm.previewFileItem) ? _c('img', {
    staticClass: "attachment-preview-image",
    attrs: {
      "src": _vm.previewFileItem.previewUrl,
      "alt": _vm.previewFileItem.name
    }
  }) : _vm.isPdf(_vm.previewFileItem) ? _c('iframe', {
    staticClass: "attachment-preview-pdf",
    attrs: {
      "src": _vm.previewFileItem.previewUrl,
      "frameborder": "0",
      "title": _vm.previewFileItem.name
    }
  }) : _vm._e()]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }